import { useCallback, memo } from 'react';
import { TradesDistrictReportGridData } from '@pages/reporting-pages/deliveries-trades-district/types/TradesDistrictReportGridData';
import { renderKilogramsToTonnes, numberWithSpaces } from 'components/global/utils';
import CellPercentBar from 'components/cell-percent-bar/CellPercentBar';



interface GridRowProps {
	item: TradesDistrictReportGridData,
	rowIndex: number,
}
  

const GridRow = (props: GridRowProps) => {
	const { rowIndex } = props;
	const { onOffTrade, tradeCode, country,
		total_volume, total_volumePct, total_weight, total_returnsWeight, total_ordersCount,
		sd_volume, sd_volumePct, sd_weight, sd_returnsWeight, sd_ordersCount,
		int_volume, int_volumePct, int_weight, int_returnsWeight, int_ordersCount,
		dd_volume, dd_volumePct, dd_weight, dd_returnsWeight, dd_ordersCount,
		td_volume, td_volumePct, td_weight, td_returnsWeight, td_ordersCount } = props.item;

	const getClassName = useCallback((centered: boolean, leftAlign: boolean = false) => 
		`app-grid-cell${
			rowIndex % 2 == 0 ? ' secondary-cell' : ' primary-cell'
		}${
			leftAlign ? ' left-align-cell' : ''
		}${
			centered ? ' centered-cell' : ''
		}`
	,[ rowIndex ]);


	return (
		<>
			<div className={getClassName(true)}>
				<p>{onOffTrade}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{country}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{tradeCode}</p>
			</div>


			<CellPercentBar
				cellClassName={getClassName(true)}
				value={total_volume}
				percentValue={total_volumePct} />

			<div className={getClassName(true)}>
				<p>{renderKilogramsToTonnes(total_weight)}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{renderKilogramsToTonnes(total_returnsWeight)}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{numberWithSpaces(total_ordersCount)}</p>
			</div>

			
			<CellPercentBar
				cellClassName={getClassName(true)}
				value={sd_volume}
				percentValue={sd_volumePct} />

			<div className={getClassName(true)}>
				<p>{renderKilogramsToTonnes(sd_weight)}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{renderKilogramsToTonnes(sd_returnsWeight)}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{numberWithSpaces(sd_ordersCount)}</p>
			</div>


			<CellPercentBar
				cellClassName={getClassName(true)}
				value={int_volume}
				percentValue={int_volumePct} />

			<div className={getClassName(true)}>
				<p>{renderKilogramsToTonnes(int_weight)}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{renderKilogramsToTonnes(int_returnsWeight)}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{numberWithSpaces(int_ordersCount)}</p>
			</div>


			<CellPercentBar
				cellClassName={getClassName(true)}
				value={dd_volume}
				percentValue={dd_volumePct} />

			<div className={getClassName(true)}>
				<p>{renderKilogramsToTonnes(dd_weight)}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{renderKilogramsToTonnes(dd_returnsWeight)}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{numberWithSpaces(dd_ordersCount)}</p>
			</div>


			<CellPercentBar
				cellClassName={getClassName(true)}
				value={td_volume}
				percentValue={td_volumePct} />

			<div className={getClassName(true)}>
				<p>{renderKilogramsToTonnes(td_weight)}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{renderKilogramsToTonnes(td_returnsWeight)}</p>
			</div>

			<div className={getClassName(true)}>
				<p>{numberWithSpaces(td_ordersCount)}</p>
			</div>
		</>
	)
}

export default memo(GridRow);